import { pipe } from 'fp-ts/function';
import { map } from 'fp-ts/lib/Either';

import { Decoding, ErrorAsync, Http } from '@catawiki/runtime-toolkit';

import { userRoutes } from '../constants/apiRoutes';
import { FavoriteId, Me, UserFavoritesResponse } from '../models/me';
import { setServerHeader } from './request';

export async function fetchCurrentUser(): ErrorAsync.PromiseEither<Me> {
  return pipe(Http.get(userRoutes.me()), setServerHeader(), Http.send<Me>())
    .then(Decoding.decodeWith(Me))
    .catch(ErrorAsync.errorToLeft);
}

export async function fetchUserFavorites(
  lotIds: number[]
): ErrorAsync.PromiseEither<FavoriteId[]> {
  return pipe(
    Http.get(userRoutes.favorites()),
    setServerHeader(),
    Http.setSearch({ lot_ids: lotIds }, { arrayFormat: 'comma' }),
    Http.send<UserFavoritesResponse>()
  )
    .then(Decoding.decodeWith(UserFavoritesResponse))
    .then(map(({ favorites }) => favorites))
    .catch(ErrorAsync.errorToLeft);
}

export async function addUserInterest(lotId: number) {
  return pipe(
    Http.postJson(userRoutes.interestsLots(), { lot_id: lotId }),
    setServerHeader(),
    Http.send()
  );
}

export async function deleteUserInterest(lotId: number) {
  return pipe(
    Http.del(`${userRoutes.interestsLots()}/${lotId}`)(),
    setServerHeader(),
    Http.send()
  );
}
